<template>
  <div class="navbar-wrapper">

    <!-- ===== TOPBAR ===== -->
    <div class="topbar">
      <div class="container">
        <div class="left">
          ✉ info@norlandproperty.com.au
        </div>
        <!-- <div class="right">
          <svg class="wechat-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor"
              d="M9.4 3C4.76 3 1 6.25 1 10.25c0 2.3 1.24 4.34 3.18 5.67L3.6 19l3.14-1.56c.85.23 1.74.36 2.66.36 4.64 0 8.4-3.25 8.4-7.25S14.04 3 9.4 3zm-3 5.17c.47 0 .86.37.86.83s-.39.83-.86.83c-.47 0-.85-.37-.85-.83s.38-.83.85-.83zm5.98 0c.47 0 .86.37.86.83s-.39.83-.86.83c-.47 0-.85-.37-.85-.83s.38-.83.85-.83z" />
            <path fill="currentColor"
              d="M16.64 9.3c-3.5 0-6.36 2.39-6.36 5.36S13.14 20 16.64 20c.7 0 1.37-.1 2-.3L21 21l-.57-2.03c1.59-.99 2.57-2.58 2.57-4.3 0-2.98-2.86-5.37-6.36-5.37zm-2.28 4.43c-.36 0-.65-.28-.65-.63s.29-.64.65-.64.65.29.65.64-.29.63-.65.63zm4.56 0c-.36 0-.65-.28-.65-.63s.29-.64.65-.64.65.29.65.64-.29.63-.65.63z" />
          </svg>
          <span class="wechat-id">norlandadvisory</span>
        </div> -->
      </div>
    </div>

    <!-- ===== MAIN NAV ===== -->
    <div :class="['main-nav', { scrolled }]">
      <div class="container nav-inner">

        <!-- LOGO -->
        <div class="logo">
          <img src="/images/logo.png" :class="{ small: scrolled }" />
        </div>

        <!-- DESKTOP MENU -->
        <ul class="menu" v-if="!isMobile">
          <li v-for="item in menu" :key="item.name" :class="{ active: isActive(item) }">
            <router-link :to="item.path">
              {{ item.name }}
            </router-link>

            <!-- Dropdown menu -->
            <ul v-if="item.children" class="dropdown">
              <li v-for="sub in item.children" :key="sub.name">
                <router-link :to="sub.path">
                  {{ sub.name }}
                </router-link>
              </li>
            </ul>
          </li>

          <li>
            <el-button class="cta-btn" @click="$router.push('/portal')">
              Member Login
            </el-button>
          </li>
        </ul>

        <!-- MOBILE HAMBURGER -->
        <div v-if="isMobile" class="hamburger" @click="toggleMobile">
          <i class="el-icon-menu"></i>
        </div>

      </div>

      <!-- MOBILE MENU -->
      <transition name="slide">
        <div v-if="isMobile && showMobile" class="mobile-menu">
          <ul>
            <li v-for="item in menu" :key="item.name" :class="{ 'mobile-active': isActive(item) }">
              <div class="mobile-item" @click="onMobileItemClick(item)">
                {{ item.name }}
                <i v-if="item.children" class="el-icon-arrow-down"></i>
              </div>

              <ul v-if="item.children && item.open">
                <li v-for="sub in item.children" :key="sub.name">
                  <router-link :to="sub.path" @click.native="toggleMobile">
                    {{ sub.name }}
                  </router-link>
                </li>
              </ul>
            </li>

            <li>
              <el-button class="cta-btn" block @click="$router.push('/portal')">
                Member Login
              </el-button>
            </li>
          </ul>
        </div>
      </transition>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      scrolled: false,
      windowWidth: window.innerWidth,
      showMobile: false,
      menu: [
        { name: 'Home', path: '/' },
        { name: 'Services', path: '/service' },
        { name: 'Portfolio', path: '/portfolio' },
        { name: 'Team', path: '/team' },
        { name: 'Research', path: '/research' },
        { name: 'Contact Us', path: '/contact' }
      ]
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 992
    }
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 60
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    toggleMobile() {
      this.showMobile = !this.showMobile
    },
    toggleSub(item) {
      if(item.children) item.open = !item.open
    },
    onMobileItemClick(item) {
      if(item.children) {
        this.toggleSub(item)
        return
      }

      if(this.$route.path !== item.path) {
        this.$router.push(item.path)
      }
      this.showMobile = false
    },
    isActive(item) {
      return this.$route.path === item.path
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 90%;
  margin: auto;
}

/* ===== TOPBAR ===== */
.topbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #0d5a50;
  color: white;
  padding: 6px 0;
  z-index: 1000;

  .container {
    display: flex;
    justify-content: space-between;
  }

  .right {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #e7f4f0;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  .wechat-icon {
    width: 18px;
    height: 18px;
    color: #9ed7c8;
    flex-shrink: 0;
  }
}

/* ===== MAIN NAV ===== */
.main-nav {
  position: fixed;
  top: 32px;
  width: 100%;
  transition: 0.4s;
  background: rgba(16, 83, 73, 0.42);
  backdrop-filter: blur(8px);
  z-index: 1000;
}

.main-nav.scrolled {
  background: #165f54;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.nav-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}

/* LOGO */
.logo img {
  height: 50px;
  transition: 0.3s;
}

.logo img.small {
  height: 38px;
}

/* DESKTOP MENU */
.menu {
  display: flex;
  list-style: none;
  align-items: center;

  li {
    position: relative;
    margin-left: 30px;

    a {
      color: white;
      text-decoration: none;
      padding-bottom: 5px;
    }

    &.active a {
      border-bottom: 2px solid #b7d5cd;
    }

    &:hover .dropdown {
      display: block;
    }
  }
}

/* DROPDOWN */
.dropdown {
  display: none;
  position: absolute;
  top: 40px;
  left: 0;
  background: #165f54;
  padding: 10px 0;
  min-width: 180px;

  li {
    padding: 8px 15px;

    a {
      color: white;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}

/* CTA */
.cta-btn {
  background: #8ab8ad;
  color: white;
  border: none;
  padding: 10px 18px;
}

/* MOBILE */
.hamburger {
  font-size: 26px;
  color: white;
  cursor: pointer;
}

.mobile-menu {
  background: linear-gradient(180deg, #0f4c43 0%, #114e45 100%);
  border-top: 1px solid rgba(196, 228, 219, 0.2);
  padding: 18px 20px 20px;

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 10px;
      border-radius: 10px;

      &.mobile-active {
        background: rgba(174, 219, 206, 0.18);
      }
    }

    a {
      color: #f1fbf8;
      text-decoration: none;
    }
  }
}

.mobile-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ecfbf7;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 12px 12px;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: rgba(174, 219, 206, 0.14);
  }
}

.mobile-menu ul ul {
  margin-top: 4px;
  padding-left: 10px;

  li {
    margin-bottom: 6px;
  }

  a {
    display: block;
    color: #dff4ee;
    font-size: 0.94rem;
    padding: 8px 10px;
    border-radius: 8px;

    &:hover {
      background: rgba(174, 219, 206, 0.12);
    }
  }
}

.mobile-menu .cta-btn {
  width: 100%;
  background: #6fae9f;
  color: #0b3029;
  font-weight: 700;
}

/* ANIMATION */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

@media (max-width: 768px) {
  .topbar {
    .right {
      font-size: 0.8rem;
      gap: 6px;
    }

    .wechat-icon {
      width: 16px;
      height: 16px;
    }
  }
}
</style>